<template>
  <div
    :class="[
      'search-wrapper',
      {
        'logged-in': userTokenAvailable && !isMobile,
        'not-logged-in': !userTokenAvailable && isMobile,
        collapsed: this.$root.isCollapsed && !isMobile,
        notification:
          userTokenAvailable &&
          this.$root.warning &&
          this.$root.warning !== 'NORMAL' &&
          !isMobile,
      },
    ]"
  >
    <div
      class="bank-name-input"
      v-if="this.userDetails?.includes('OFFLINE_ORDERS')"
    >
      <div class="banks-list-wrapper">
        <select
          class="banks-list"
          v-model="bankName"
          :style="{
            color: bankName === null ? '#757575' : '#224096',
          }"
        >
          <option value="null" disabled>{{ $t("select-bank") }}</option>
          <option v-for="(bank, index) in banksList" :key="index" :value="bank">
            {{ bank.name }}
          </option>
        </select>
      </div>
    </div>
    <!-- Search -->
    <div
      class="frame-3"
      :class="{ 'search-wrapper-not-logged': !userTokenAvailable && !isMobile }"
      :style="{ marginTop: this.userDetails?.includes('OFFLINE_ORDERS') && 0 }"
    >
      <div class="search-bar-wrapper">
        <div class="search-comp">
          <div class="search-input">
            <input
              type="text"
              :placeholder="`${$t('search-company')}`"
              class="enter-email-address"
              style="width: 100%"
              autocomplete="off"
              id="company_name"
              v-model="company_name"
            />
          </div>
          <div class="frame-6" style="cursor: pointer; gap: 0">
            <input
              type="text"
              :placeholder="`${$t('select-country')}`"
              :value="selectedCountry.name"
              @input="updateSelectedCountry"
              class="enter-email-address"
              style="width: 100%; cursor: pointer; padding-right: 5px"
              ref="searchInput"
              @click="showResults1"
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="{
                'rotate-180': showResultsFlag1,
                'rotate-0': !showResultsFlag1,
              }"
              @click="toggleDropdown1"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              class="country-results"
              v-if="showResultsFlag1"
              ref="countryResults"
            >
              <div
                v-for="country in filteredCountries"
                :key="country.id"
                @click="selectCountry1(country)"
              >
                <template v-if="isWindows()"
                  ><img
                    :src="country.flagImage"
                    alt="Flag"
                    class="flag-image"
                  />
                  {{ country.name }}</template
                >
                <template v-else
                  >{{ country.flagEmoji }} {{ country.name }}</template
                >
              </div>
            </div>
          </div>
          <div
            class="search-button"
            v-on:click.prevent="uploadedFile == null && search()"
            :style="uploadedFile !== null && { cursor: 'not-allowed' }"
          >
            {{ $t("search") }}
          </div>
        </div>
        <div
          class="manual-order-cta"
          v-if="
            searchResults == null || (searchResults && searchResults.length > 0)
          "
          @click="uploadedFile == null && tokenAPI()"
          :style="uploadedFile !== null && { cursor: 'not-allowed' }"
        >
          {{
            userDetails?.includes("OFFLINE_ORDERS")
              ? $t("place-single")
              : windowWidth > 1190
              ? $t("place-manual")
              : windowWidth < 1190 && windowWidth > 768
              ? $t("manual")
              : $t("place-manual")
          }}
        </div>
      </div>
    </div>
    <!--Pi Upload Section  -->
    <div class="pi-wrapper" v-if="isPiFlowAccessible && uploadedFile == null">
      <div class="pi-frame">
        <div class="pi-content">
          <span class="pi-heading"
            >{{ $t("proforma")
            }}<span class="beta-version">{{ $t("beta") }}</span></span
          >
          <p class="pi-subheading">{{ $t("guidelines") }}</p>
          <ul class="pi-list">
            <li>{{ $t("upload-pi") }}</li>
            <li>{{ $t("allowed-file") }}</li>
          </ul>
        </div>
        <div class="pi-button-wrapper">
          <button class="pi-button" @click="triggerFileUpload">
            {{ $t("pi-cta") }}
          </button>
          <input
            ref="fileInput"
            type="file"
            @change="handleFileUpload"
            accept="image/*,.pdf,"
            style="display: none"
          />
        </div>
      </div>
    </div>
    <!-- Progress Bar -->
    <div
      :class="mobile ? 'progress-wrapper1' : 'progress-wrapper'"
      v-if="isPiFlowAccessible && uploadedFile !== null"
    >
      <div :class="mobile ? 'progress-frame1' : 'progress-frame'">
        <div class="progress-cards">
          <div class="progress-icons">
            <img
              src="../assets/Icons/uploadIcon.svg"
              alt="Upload Icon"
              class="img-icon"
            />
          </div>
          <div class="progress-text">{{ $t("uploading") }}</div>
        </div>
        <div class="rectangle-wrapper" v-if="!mobile">
          <div
            class="frame-child"
            :style="{ width: `${progressWidth}%` }"
          ></div>
        </div>
        <div class="progress-cards">
          <div class="progress-icons">
            <img
              src="../assets/Icons/progressIcon.svg"
              alt="Processing Icon"
              class="img-icon"
            />
          </div>
          <div class="progress-text" style="color: #224096">
            {{ $t("processing") }}
          </div>
        </div>
        <div class="rectangle-wrapper" v-if="!mobile">
          <div class="frame-child1" :style="{ width: '0%' }"></div>
        </div>
        <div class="progress-cards">
          <div class="progress-icons">
            <img
              src="../assets/Icons/cart.svg"
              alt="Cart Icon"
              class="img-icon"
            />
          </div>
          <div class="progress-text" style="color: #224096">
            {{ $t("place-order") }}
          </div>
        </div>
      </div>
      <!-- for mobile view -->
      <div class="rectangle-wrapper" v-if="mobile">
        <div class="frame-child" :style="{ width: `${progressWidth}%` }"></div>
      </div>
    </div>
    <!-- Search Results Section -->
    <div class="search-results">
      <div
        id="manual-order-div"
        v-if="searchResults && searchResults.length == 0"
      >
        <div style="display: flex; flex-direction: column">
          <NoData2 />
          <span style="font-weight: bold">{{ $t("no-results") }}</span>
        </div>
        <button id="manual-order-button" v-on:click.prevent="tokenAPI()" cursor>
          {{
            userDetails?.includes("OFFLINE_ORDERS")
              ? $t("place-single")
              : $t("place-manual")
          }}
        </button>
      </div>
      <div
        class="search-page-animation-wrapper"
        v-if="isLoading == true && searchResults == null"
      >
        <SearchAnimation />
        <div class="search-page-animation-text">{{ $t("search-for") }}</div>
        <div
          class="search-page-animation-text-2"
          v-if="this.$root.userTokenAvailable"
        >
          {{ $t("sample-reports") }}
        </div>
        <div
          v-if="this.$root.userTokenAvailable"
          class="search-page-animation-button"
          @click="redirectToSampleReports"
        >
          {{ $t("view-sample") }}
        </div>
      </div>
      <div
        class="main-wrapper"
        v-if="searchResults && searchResults.length > 0"
      >
        <div
          class="search-content-wrapper"
          :style="{ width: contentWrapperWidth }"
        >
          <!-- <div
            class="recent-searches"
            v-if="recentSearches && recentSearches?.length > 0"
          >
            <div class="frame-132">
              <div class="recent-searches-title">Recently Searched</div>
              <div class="clear-all-button">Clear All</div>
            </div>
            <div class="frame-1321">
              <div
                v-for="search in recentSearches.slice(0, 10)"
                :key="search.id"
                class="recent-search-capsule"
                @click="recentSearch(search)"
              >
                <span class="company-name">{{ search.companyName }}</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.067 15.1827C16.1251 15.2407 16.1712 15.3097 16.2026 15.3855C16.234 15.4614 16.2502 15.5427 16.2502 15.6249C16.2502 15.707 16.234 15.7883 16.2026 15.8642C16.1712 15.94 16.1251 16.009 16.067 16.067C16.009 16.1251 15.94 16.1712 15.8642 16.2026C15.7883 16.234 15.707 16.2502 15.6249 16.2502C15.5427 16.2502 15.4614 16.234 15.3855 16.2026C15.3097 16.1712 15.2407 16.1251 15.1827 16.067L9.99986 10.8835L4.81705 16.067C4.69977 16.1843 4.54071 16.2502 4.37486 16.2502C4.20901 16.2502 4.04995 16.1843 3.93267 16.067C3.8154 15.9498 3.74951 15.7907 3.74951 15.6249C3.74951 15.459 3.8154 15.2999 3.93267 15.1827L9.11627 9.99986L3.93267 4.81705C3.8154 4.69977 3.74951 4.54071 3.74951 4.37486C3.74951 4.20901 3.8154 4.04995 3.93267 3.93267C4.04995 3.8154 4.20901 3.74951 4.37486 3.74951C4.54071 3.74951 4.69977 3.8154 4.81705 3.93267L9.99986 9.11627L15.1827 3.93267C15.2999 3.8154 15.459 3.74951 15.6249 3.74951C15.7907 3.74951 15.9498 3.8154 16.067 3.93267C16.1843 4.04995 16.2502 4.20901 16.2502 4.37486C16.2502 4.54071 16.1843 4.69977 16.067 4.81705L10.8835 9.99986L16.067 15.1827Z"
                    fill="#3E4855"
                  />
                </svg>
              </div>
            </div>
          </div> -->
          <div class="notes" v-if="searchResults && searchResults.length > 0">
            <div class="note-title">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="windowWidth >= 768"
              >
                <path
                  d="M10.0003 9.1665C9.77932 9.1665 9.56735 9.2543 9.41107 9.41058C9.25479 9.56686 9.167 9.77882 9.167 9.99984V13.3332C9.167 13.5542 9.25479 13.7661 9.41107 13.9224C9.56735 14.0787 9.77932 14.1665 10.0003 14.1665C10.2213 14.1665 10.4333 14.0787 10.5896 13.9224C10.7459 13.7661 10.8337 13.5542 10.8337 13.3332V9.99984C10.8337 9.77882 10.7459 9.56686 10.5896 9.41058C10.4333 9.2543 10.2213 9.1665 10.0003 9.1665ZM10.317 5.89984C10.1141 5.81649 9.88655 5.81649 9.68366 5.89984C9.58137 5.9395 9.48792 5.99897 9.40866 6.07484C9.33505 6.15584 9.27586 6.24885 9.23366 6.34984C9.18701 6.44874 9.16418 6.55719 9.167 6.6665C9.16636 6.77618 9.18738 6.88489 9.22885 6.98643C9.27032 7.08796 9.33143 7.1803 9.40866 7.25817C9.48966 7.33178 9.58267 7.39097 9.68366 7.43317C9.80991 7.48504 9.94697 7.5051 10.0828 7.4916C10.2186 7.47809 10.349 7.43144 10.4626 7.35573C10.5762 7.28002 10.6694 7.17757 10.7341 7.0574C10.7988 6.93722 10.833 6.80299 10.8337 6.6665C10.8306 6.44587 10.7443 6.23453 10.592 6.07484C10.5127 5.99897 10.4193 5.9395 10.317 5.89984ZM10.0003 1.6665C8.35215 1.6665 6.74099 2.15525 5.37058 3.07092C4.00017 3.9866 2.93206 5.28809 2.30133 6.81081C1.6706 8.33353 1.50558 10.0091 1.82712 11.6256C2.14866 13.2421 2.94234 14.727 4.10777 15.8924C5.27321 17.0578 6.75807 17.8515 8.37458 18.173C9.99109 18.4946 11.6666 18.3296 13.1894 17.6988C14.7121 17.0681 16.0136 16 16.9292 14.6296C17.8449 13.2592 18.3337 11.648 18.3337 9.99984C18.3337 8.90549 18.1181 7.82186 17.6993 6.81081C17.2805 5.79976 16.6667 4.8811 15.8929 4.10728C15.1191 3.33346 14.2004 2.71963 13.1894 2.30084C12.1783 1.88205 11.0947 1.6665 10.0003 1.6665ZM10.0003 16.6665C8.68179 16.6665 7.39286 16.2755 6.29653 15.543C5.2002 14.8104 4.34572 13.7692 3.84113 12.5511C3.33655 11.3329 3.20453 9.99244 3.46176 8.69924C3.719 7.40603 4.35393 6.21814 5.28628 5.28579C6.21863 4.35344 7.40652 3.7185 8.69973 3.46127C9.99293 3.20403 11.3334 3.33606 12.5516 3.84064C13.7697 4.34522 14.8109 5.19971 15.5435 6.29604C16.276 7.39236 16.667 8.6813 16.667 9.99984C16.667 11.7679 15.9646 13.4636 14.7144 14.7139C13.4641 15.9641 11.7684 16.6665 10.0003 16.6665Z"
                  fill="#046BE1"
                />
              </svg>
              <span>
                <span style="font-weight: 600">{{ $t("note") }}:</span>
                <span class="note-text">
                  {{
                    selectedCountry?.searchNotes !== null
                      ? selectedCountry?.searchNotes?.REPORT_COMPREHENSIVE
                      : "note-text" + selectedCountry?.name + "."
                  }}
                </span>
              </span>
            </div>
          </div>

          <div
            class="table-container"
            v-if="searchResults && searchResults.length > 0"
          >
            <div class="total-search-results">
              {{ searchResults.length }} {{ $t("results-found") }}
            </div>
            <!------- Start Repeated Report Section ---------->
            <div
              class="delivered-reports-wrapper"
              v-if="pastEntityOrders !== null"
              :style="{
                // boxShadow: showBoxShadow ? '0px 0px 24px 0px red' : 'none',
                animation: showBlinking
                  ? 'blinking 1s linear infinite'
                  : 'none',
              }"
            >
              <div class="send-report-wrapper">
                <div class="send-report-title-wrapper">
                  <div class="send-report-title">
                    {{ $t("already-available") }}
                  </div>
                  <div class="send-report-title-2">
                    {{ $t("report-dated") }}
                    {{ pastEntityOrders?.reportDated }}
                    {{ $t("available-for-you") }}
                  </div>
                </div>
                <div
                  class="send-report-button"
                  :style="{
                    background: '#EFCC3A',
                    color: '#224096',
                  }"
                  v-if="
                    pastEntityOrders?.reportFileKey &&
                    pastEntityOrders?.reportFileName
                  "
                  @click="
                    downloadReport(
                      pastEntityOrders?.reportFileKey,
                      pastEntityOrders?.reportFileName
                    )
                  "
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style="margin-left: 10px"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    v-if="piFileKey !== null"
                  >
                    <path
                      d="M20.2502 13.5001C20.4492 13.5001 20.6399 13.5791 20.7806 13.7198C20.9212 13.8604 21.0002 14.0512 21.0002 14.2501V19.5001C21.0002 19.8979 20.8422 20.2794 20.5609 20.5608C20.2796 20.8421 19.8981 21.0001 19.5002 21.0001H4.50024C4.10242 21.0001 3.72089 20.8421 3.43958 20.5607C3.15828 20.2794 3.00024 19.8979 3.00024 19.5001L3.00024 14.2501C3.00024 14.0512 3.07926 13.8604 3.21991 13.7198C3.36057 13.5791 3.55133 13.5001 3.75024 13.5001C3.94916 13.5001 4.13992 13.5791 4.28057 13.7198C4.42123 13.8604 4.50024 14.0512 4.50024 14.2501L4.50024 19.5001H19.5002V14.2501C19.5002 14.0512 19.5793 13.8604 19.7199 13.7198C19.8606 13.5791 20.0513 13.5001 20.2502 13.5001Z"
                      fill="#224096"
                    />
                    <path
                      d="M7.71962 11.0301L11.4696 14.7801C11.5393 14.8499 11.622 14.9052 11.713 14.9429C11.8041 14.9807 11.9017 15.0001 12.0002 15.0001C12.0988 15.0001 12.1964 14.9807 12.2874 14.9429C12.3785 14.9052 12.4612 14.8499 12.5309 14.7801L16.2809 11.0301C16.4216 10.8894 16.5007 10.6985 16.5007 10.4995C16.5007 10.3005 16.4216 10.1096 16.2809 9.96889C16.1401 9.82816 15.9493 9.74909 15.7502 9.74909C15.5512 9.74909 15.3603 9.82816 15.2196 9.96889L12.7502 12.4392V3.74951C12.7502 3.5506 12.6712 3.35983 12.5306 3.21918C12.3899 3.07853 12.1992 2.99951 12.0002 2.99951C11.8013 2.99951 11.6106 3.07853 11.4699 3.21918C11.3293 3.35983 11.2502 3.5506 11.2502 3.74951V12.4392L8.78087 9.96889C8.64014 9.82816 8.44927 9.74909 8.25024 9.74909C8.05122 9.74909 7.86035 9.82816 7.71962 9.96889C7.57889 10.1096 7.49983 10.3005 7.49983 10.4995C7.49983 10.6985 7.57889 10.8894 7.71962 11.0301Z"
                      fill="#224096"
                    />
                  </svg>
                  <span>{{ $t("download") }}</span>
                </div>
                <div
                  class="send-report-button"
                  :style="{
                    opacity: sendReportButton ? 0.4 : 1,
                    background: '#EFCC3A',
                    color: '#224096',
                  }"
                  v-else
                  @click="
                    !sendReportButton &&
                      RequestAvailableReport(pastEntityOrders)
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21.4163 8.37562L12.4163 2.37562C12.293 2.29339 12.1482 2.24951 12 2.24951C11.8518 2.24951 11.707 2.29339 11.5837 2.37562L2.58375 8.37562C2.48101 8.44417 2.39679 8.53703 2.33857 8.64595C2.28034 8.75488 2.24992 8.87649 2.25 9V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V9C21.7501 8.87649 21.7197 8.75488 21.6614 8.64595C21.6032 8.53703 21.519 8.44417 21.4163 8.37562ZM9.0675 14.25L3.75 18V10.4559L9.0675 14.25ZM10.6022 15H13.3978L18.7069 18.75H5.29312L10.6022 15ZM14.9325 14.25L20.25 10.4559V18L14.9325 14.25ZM12 3.90094L19.6791 9.02062L13.3978 13.5H10.6041L4.32281 9.02062L12 3.90094Z"
                      fill="#224096"
                    />
                  </svg>
                  <span>{{
                    sendReportButton ? $t("sending") : $t("free")
                  }}</span>
                </div>
              </div>
              <div class="send-report-company-name-wrapper">
                <div class="send-report-company-name-title">
                  {{ $t("company-name1") }}
                </div>
                <div
                  class="send-report-company-name"
                  style="text-transform: capitalize"
                >
                  {{ pastEntityOrders.company_name.toLowerCase() }}
                </div>
              </div>
              <div class="send-report-company-name-wrapper">
                <div class="send-report-company-name-title">
                  {{ $t("company-address") }}
                </div>
                <div class="send-report-company-name">
                  {{ pastEntityOrders?.additional_info?.business_address }}
                </div>
              </div>
            </div>
            <!------- End Repeated Report Section ---------->
            <!------- Start Show Search Results ---------->
            <table
              id="searchResultTable"
              v-if="
                searchResults && searchResults.length > 0 && windowWidth > 1023
              "
            >
              <thead>
                <tr>
                  <th v-for="col in tabelColumns" :key="col">{{ col }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  id="result-wrapper"
                  :style="hoveredRow === index ? hoverStyle : {}"
                  @mouseover="setHover(index)"
                  @mouseout="clearHover"
                  v-for="(searchResult, index) in searchResults"
                  :key="index"
                >
                  <td
                    style="
                      font-weight: 600;
                      padding-left: 30px;
                      text-transform: capitalize;
                      cursor: pointer;
                    "
                  >
                    {{ searchResult.company_name.toLowerCase() }}
                  </td>
                  <td>
                    <InformationList
                      :information="
                        rearrangedAdditionalInfo(searchResult?.additional_info)
                      "
                    />
                  </td>
                  <td>
                    <div id="order-buttons">
                      <div
                        style="padding-left: 10px; padding-right: 10px"
                        :key="index"
                      >
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            background-color: #224096;
                            border-radius: 10px;
                            width: 195.96px;
                            padding: 5px 10px;
                          "
                          @click="passClickedData(searchResult, 'FRESH')"
                        >
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.0835 20.25C10.0835 20.5467 9.99552 20.8367 9.8307 21.0834C9.66588 21.33 9.43161 21.5223 9.15752 21.6358C8.88343 21.7494 8.58183 21.7791 8.29086 21.7212C7.99989 21.6633 7.73261 21.5204 7.52284 21.3107C7.31306 21.1009 7.1702 20.8336 7.11232 20.5426C7.05444 20.2517 7.08415 19.9501 7.19768 19.676C7.31121 19.4019 7.50347 19.1676 7.75014 19.0028C7.99681 18.838 8.28682 18.75 8.5835 18.75C8.98132 18.75 9.36285 18.908 9.64416 19.1893C9.92546 19.4706 10.0835 19.8522 10.0835 20.25ZM18.3335 18.75C18.0368 18.75 17.7468 18.838 17.5001 19.0028C17.2535 19.1676 17.0612 19.4019 16.9477 19.676C16.8341 19.9501 16.8044 20.2517 16.8623 20.5426C16.9202 20.8336 17.0631 21.1009 17.2728 21.3107C17.4826 21.5204 17.7499 21.6633 18.0409 21.7212C18.3318 21.7791 18.6334 21.7494 18.9075 21.6358C19.1816 21.5223 19.4159 21.33 19.5807 21.0834C19.7455 20.8367 19.8335 20.5467 19.8335 20.25C19.8335 19.8522 19.6755 19.4706 19.3942 19.1893C19.1129 18.908 18.7313 18.75 18.3335 18.75ZM22.8063 6.95062L20.4026 15.6019C20.2704 16.0745 19.9877 16.4911 19.5974 16.7885C19.2071 17.0859 18.7305 17.2479 18.2397 17.25H8.9735C8.48134 17.2498 8.00276 17.0886 7.61074 16.791C7.21873 16.4935 6.9348 16.0758 6.80225 15.6019L3.5135 3.75H1.8335C1.63458 3.75 1.44382 3.67098 1.30317 3.53033C1.16251 3.38968 1.0835 3.19891 1.0835 3C1.0835 2.80109 1.16251 2.61032 1.30317 2.46967C1.44382 2.32902 1.63458 2.25 1.8335 2.25H4.0835C4.24747 2.24997 4.40693 2.30367 4.53747 2.40289C4.66802 2.50211 4.76245 2.64138 4.80631 2.79938L5.69506 6H22.0835C22.1991 5.99998 22.3132 6.02669 22.4168 6.07805C22.5204 6.1294 22.6107 6.20401 22.6807 6.29605C22.7506 6.38809 22.7984 6.49506 22.8202 6.60861C22.842 6.72216 22.8372 6.83922 22.8063 6.95062ZM21.0963 7.5H6.11225L8.25068 15.2006C8.29455 15.3586 8.38898 15.4979 8.51952 15.5971C8.65006 15.6963 8.80953 15.75 8.9735 15.75H18.2397C18.4037 15.75 18.5632 15.6963 18.6937 15.5971C18.8243 15.4979 18.9187 15.3586 18.9626 15.2006L21.0963 7.5Z"
                              fill="white"
                            />
                          </svg>

                          <span
                            style="
                              margin-left: 12px;
                              color: white;
                              font-weight: 500;
                            "
                            >{{ $t("buy-report") }}</span
                          >
                        </div>
                        <br />
                        <!--------Start Discount Section ------------>
                        <div
                          class="login-discounts"
                          v-if="!userTokenAvailable"
                          @click="redirectToLogin('Login')"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                          >
                            <path
                              d="M20.5835 6.74984H17.2947C17.3313 6.71891 17.3688 6.68891 17.4044 6.65609C17.6892 6.40314 17.9186 6.09415 18.0785 5.74846C18.2384 5.40276 18.3252 5.02781 18.3335 4.64703C18.3458 4.23048 18.2729 3.8158 18.1191 3.42846C17.9654 3.04112 17.7341 2.68928 17.4394 2.39456C17.1448 2.09984 16.7931 1.86845 16.4058 1.71459C16.0185 1.56073 15.6038 1.48765 15.1872 1.49984C14.8063 1.50805 14.4312 1.5948 14.0853 1.75466C13.7395 1.91453 13.4303 2.14406 13.1772 2.42891C12.8271 2.83474 12.5424 3.29276 12.3335 3.78641C12.1246 3.29276 11.8399 2.83474 11.4897 2.42891C11.2367 2.14406 10.9275 1.91453 10.5817 1.75466C10.2358 1.5948 9.86068 1.50805 9.47975 1.49984C9.06319 1.48765 8.64853 1.56073 8.26123 1.71459C7.87394 1.86845 7.52218 2.09984 7.22754 2.39456C6.93291 2.68928 6.70162 3.04112 6.54788 3.42846C6.39413 3.8158 6.32118 4.23048 6.3335 4.64703C6.34183 5.02781 6.42864 5.40276 6.5885 5.74846C6.74836 6.09415 6.97783 6.40314 7.26256 6.65609C7.29818 6.68703 7.33568 6.71703 7.37225 6.74984H4.0835C3.68567 6.74984 3.30414 6.90788 3.02284 7.18918C2.74153 7.47049 2.5835 7.85202 2.5835 8.24984V11.2498C2.5835 11.6477 2.74153 12.0292 3.02284 12.3105C3.30414 12.5918 3.68567 12.7498 4.0835 12.7498V18.7498C4.0835 19.1477 4.24153 19.5292 4.52284 19.8105C4.80414 20.0918 5.18567 20.2498 5.5835 20.2498H19.0835C19.4813 20.2498 19.8629 20.0918 20.1442 19.8105C20.4255 19.5292 20.5835 19.1477 20.5835 18.7498V12.7498C20.9813 12.7498 21.3629 12.5918 21.6442 12.3105C21.9255 12.0292 22.0835 11.6477 22.0835 11.2498V8.24984C22.0835 7.85202 21.9255 7.47049 21.6442 7.18918C21.3629 6.90788 20.9813 6.74984 20.5835 6.74984ZM14.3022 3.42266C14.421 3.29152 14.5656 3.18635 14.7269 3.11375C14.8882 3.04115 15.0628 3.00269 15.2397 3.00078H15.2857C15.493 3.00208 15.698 3.04475 15.8887 3.12629C16.0793 3.20783 16.2518 3.3266 16.3959 3.47564C16.5401 3.62468 16.653 3.801 16.7282 3.99425C16.8033 4.18751 16.8391 4.39382 16.8335 4.60109C16.8316 4.778 16.7931 4.9526 16.7205 5.11393C16.6479 5.27526 16.5428 5.41984 16.4116 5.53859C15.5219 6.32609 14.0454 6.60359 13.1304 6.70109C13.2429 5.70828 13.5522 4.26547 14.3022 3.42266ZM8.29381 3.45641C8.58438 3.16587 8.9779 3.00179 9.38881 2.99984H9.43475C9.61165 3.00175 9.78625 3.04021 9.94758 3.11281C10.1089 3.18541 10.2535 3.29058 10.3722 3.42172C11.1588 4.31047 11.4363 5.78422 11.5338 6.69547C10.6226 6.60172 9.14881 6.32047 8.26006 5.53391C8.12892 5.41516 8.02375 5.27057 7.95115 5.10924C7.87855 4.94791 7.84009 4.77331 7.83818 4.59641C7.83237 4.38569 7.86942 4.17599 7.9471 3.98002C8.02478 3.78406 8.14146 3.60592 8.29006 3.45641H8.29381ZM4.0835 8.24984H11.5835V11.2498H4.0835V8.24984ZM5.5835 12.7498H11.5835V18.7498H5.5835V12.7498ZM19.0835 18.7498H13.0835V12.7498H19.0835V18.7498ZM20.5835 11.2498H13.0835V8.24984H20.5835V11.2498Z"
                              fill="#224096"
                            />
                          </svg>
                          <span>{{ $t("login-for-discount") }}</span>
                        </div>
                        <!--------End Discount Section ------------>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!------- End Show Search Results ---------->
            <!------ Start Additional Info Section -------->
            <div v-else class="search-results-card">
              <div
                v-for="(searchResult, index) in searchResults"
                :key="index"
                class="company-info-wrapper"
              >
                <div class="wrapper">
                  <div class="company-name-tablet">
                    {{ searchResult.company_name }}
                  </div>
                  <div class="company-description">
                    <InformationList
                      :information="
                        rearrangedAdditionalInfo(searchResult?.additional_info)
                      "
                      v-if="windowWidth > 767"
                    />
                    <div class="info-wrapper" v-else>
                      <div
                        class="phone-view-info-wrapper"
                        v-if="
                          Object.prototype.hasOwnProperty.call(
                            searchResult?.additional_info,
                            'company_address'
                          )
                        "
                      >
                        <div class="cin-identifiers">{{ $t("address") }}</div>
                        <div
                          class="identifiers-value"
                          style="text-transform: capitalize"
                        >
                          {{
                            searchResult?.additional_info?.company_address.toLowerCase()
                          }}
                        </div>
                      </div>
                      <div
                        class="phone-view-info-wrapper"
                        v-if="searchResult?.additional_info?.business_address"
                      >
                        <div class="cin-identifiers">
                          {{ $t("business-address") }}
                        </div>
                        <div
                          class="identifiers-value"
                          style="text-transform: capitalize"
                        >
                          {{
                            searchResult?.additional_info?.business_address.toLowerCase()
                          }}
                        </div>
                      </div>
                      <div
                        v-if="
                          searchResult?.additional_info
                            ?.company_identifiers?.[0]?.value &&
                          searchResult?.additional_info
                            ?.company_identifiers?.[0]?.name !== 'WIN'
                        "
                        class="phone-view-info-wrapper"
                      >
                        <div class="cin-identifiers">
                          {{ $t("company-iden") }} ({{
                            searchResult?.additional_info
                              ?.company_identifiers?.[0]?.name
                          }})
                        </div>
                        <div class="identifiers-value">
                          {{
                            searchResult?.additional_info
                              ?.company_identifiers?.[0]?.value
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="order-button-wrapper">
                  <div id="order-buttons-tablet">
                    <div
                      style="padding-left: 10px; padding-right: 10px"
                      :key="index"
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                          cursor: pointer;
                          background-color: #224096;
                          border-radius: 10px;
                          width: max-content;
                          padding: 3px 10px;
                        "
                        @click="passClickedData(searchResult, 'FRESH')"
                      >
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0835 20.25C10.0835 20.5467 9.99552 20.8367 9.8307 21.0834C9.66588 21.33 9.43161 21.5223 9.15752 21.6358C8.88343 21.7494 8.58183 21.7791 8.29086 21.7212C7.99989 21.6633 7.73261 21.5204 7.52284 21.3107C7.31306 21.1009 7.1702 20.8336 7.11232 20.5426C7.05444 20.2517 7.08415 19.9501 7.19768 19.676C7.31121 19.4019 7.50347 19.1676 7.75014 19.0028C7.99681 18.838 8.28682 18.75 8.5835 18.75C8.98132 18.75 9.36285 18.908 9.64416 19.1893C9.92546 19.4706 10.0835 19.8522 10.0835 20.25ZM18.3335 18.75C18.0368 18.75 17.7468 18.838 17.5001 19.0028C17.2535 19.1676 17.0612 19.4019 16.9477 19.676C16.8341 19.9501 16.8044 20.2517 16.8623 20.5426C16.9202 20.8336 17.0631 21.1009 17.2728 21.3107C17.4826 21.5204 17.7499 21.6633 18.0409 21.7212C18.3318 21.7791 18.6334 21.7494 18.9075 21.6358C19.1816 21.5223 19.4159 21.33 19.5807 21.0834C19.7455 20.8367 19.8335 20.5467 19.8335 20.25C19.8335 19.8522 19.6755 19.4706 19.3942 19.1893C19.1129 18.908 18.7313 18.75 18.3335 18.75ZM22.8063 6.95062L20.4026 15.6019C20.2704 16.0745 19.9877 16.4911 19.5974 16.7885C19.2071 17.0859 18.7305 17.2479 18.2397 17.25H8.9735C8.48134 17.2498 8.00276 17.0886 7.61074 16.791C7.21873 16.4935 6.9348 16.0758 6.80225 15.6019L3.5135 3.75H1.8335C1.63458 3.75 1.44382 3.67098 1.30317 3.53033C1.16251 3.38968 1.0835 3.19891 1.0835 3C1.0835 2.80109 1.16251 2.61032 1.30317 2.46967C1.44382 2.32902 1.63458 2.25 1.8335 2.25H4.0835C4.24747 2.24997 4.40693 2.30367 4.53747 2.40289C4.66802 2.50211 4.76245 2.64138 4.80631 2.79938L5.69506 6H22.0835C22.1991 5.99998 22.3132 6.02669 22.4168 6.07805C22.5204 6.1294 22.6107 6.20401 22.6807 6.29605C22.7506 6.38809 22.7984 6.49506 22.8202 6.60861C22.842 6.72216 22.8372 6.83922 22.8063 6.95062ZM21.0963 7.5H6.11225L8.25068 15.2006C8.29455 15.3586 8.38898 15.4979 8.51952 15.5971C8.65006 15.6963 8.80953 15.75 8.9735 15.75H18.2397C18.4037 15.75 18.5632 15.6963 18.6937 15.5971C18.8243 15.4979 18.9187 15.3586 18.9626 15.2006L21.0963 7.5Z"
                            fill="white"
                          />
                        </svg>

                        <span
                          style="
                            margin-left: 12px;
                            color: white;
                            font-weight: 500;
                          "
                          >{{ $t("buy-report") }}</span
                        >
                      </div>
                      <br />
                      <div
                        class="login-discounts"
                        v-if="!userTokenAvailable"
                        @click="redirectToLogin('Login')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M20.5835 6.74984H17.2947C17.3313 6.71891 17.3688 6.68891 17.4044 6.65609C17.6892 6.40314 17.9186 6.09415 18.0785 5.74846C18.2384 5.40276 18.3252 5.02781 18.3335 4.64703C18.3458 4.23048 18.2729 3.8158 18.1191 3.42846C17.9654 3.04112 17.7341 2.68928 17.4394 2.39456C17.1448 2.09984 16.7931 1.86845 16.4058 1.71459C16.0185 1.56073 15.6038 1.48765 15.1872 1.49984C14.8063 1.50805 14.4312 1.5948 14.0853 1.75466C13.7395 1.91453 13.4303 2.14406 13.1772 2.42891C12.8271 2.83474 12.5424 3.29276 12.3335 3.78641C12.1246 3.29276 11.8399 2.83474 11.4897 2.42891C11.2367 2.14406 10.9275 1.91453 10.5817 1.75466C10.2358 1.5948 9.86068 1.50805 9.47975 1.49984C9.06319 1.48765 8.64853 1.56073 8.26123 1.71459C7.87394 1.86845 7.52218 2.09984 7.22754 2.39456C6.93291 2.68928 6.70162 3.04112 6.54788 3.42846C6.39413 3.8158 6.32118 4.23048 6.3335 4.64703C6.34183 5.02781 6.42864 5.40276 6.5885 5.74846C6.74836 6.09415 6.97783 6.40314 7.26256 6.65609C7.29818 6.68703 7.33568 6.71703 7.37225 6.74984H4.0835C3.68567 6.74984 3.30414 6.90788 3.02284 7.18918C2.74153 7.47049 2.5835 7.85202 2.5835 8.24984V11.2498C2.5835 11.6477 2.74153 12.0292 3.02284 12.3105C3.30414 12.5918 3.68567 12.7498 4.0835 12.7498V18.7498C4.0835 19.1477 4.24153 19.5292 4.52284 19.8105C4.80414 20.0918 5.18567 20.2498 5.5835 20.2498H19.0835C19.4813 20.2498 19.8629 20.0918 20.1442 19.8105C20.4255 19.5292 20.5835 19.1477 20.5835 18.7498V12.7498C20.9813 12.7498 21.3629 12.5918 21.6442 12.3105C21.9255 12.0292 22.0835 11.6477 22.0835 11.2498V8.24984C22.0835 7.85202 21.9255 7.47049 21.6442 7.18918C21.3629 6.90788 20.9813 6.74984 20.5835 6.74984ZM14.3022 3.42266C14.421 3.29152 14.5656 3.18635 14.7269 3.11375C14.8882 3.04115 15.0628 3.00269 15.2397 3.00078H15.2857C15.493 3.00208 15.698 3.04475 15.8887 3.12629C16.0793 3.20783 16.2518 3.3266 16.3959 3.47564C16.5401 3.62468 16.653 3.801 16.7282 3.99425C16.8033 4.18751 16.8391 4.39382 16.8335 4.60109C16.8316 4.778 16.7931 4.9526 16.7205 5.11393C16.6479 5.27526 16.5428 5.41984 16.4116 5.53859C15.5219 6.32609 14.0454 6.60359 13.1304 6.70109C13.2429 5.70828 13.5522 4.26547 14.3022 3.42266ZM8.29381 3.45641C8.58438 3.16587 8.9779 3.00179 9.38881 2.99984H9.43475C9.61165 3.00175 9.78625 3.04021 9.94758 3.11281C10.1089 3.18541 10.2535 3.29058 10.3722 3.42172C11.1588 4.31047 11.4363 5.78422 11.5338 6.69547C10.6226 6.60172 9.14881 6.32047 8.26006 5.53391C8.12892 5.41516 8.02375 5.27057 7.95115 5.10924C7.87855 4.94791 7.84009 4.77331 7.83818 4.59641C7.83237 4.38569 7.86942 4.17599 7.9471 3.98002C8.02478 3.78406 8.14146 3.60592 8.29006 3.45641H8.29381ZM4.0835 8.24984H11.5835V11.2498H4.0835V8.24984ZM5.5835 12.7498H11.5835V18.7498H5.5835V12.7498ZM19.0835 18.7498H13.0835V12.7498H19.0835V18.7498ZM20.5835 11.2498H13.0835V8.24984H20.5835V11.2498Z"
                            fill="#224096"
                          />
                        </svg>
                        <span>{{ $t("login-for-discount") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!------ End Additional Info Section --------->
          </div>
          <div
            class="manual-order"
            v-if="searchResults && searchResults.length > 0"
          >
            <div class="manual-order-text">
              {{ $t("couldent") }}
            </div>
            <div class="manual-order-button-2" @click="tokenAPI()">
              {{
                userDetails?.includes("OFFLINE_ORDERS")
                  ? $t("place-single")
                  : $t("place-manual")
              }}
            </div>
          </div>
        </div>
        <div v-if="!userTokenAvailable" ref="loginCard" class="login-card">
          <div class="loginwrapper">
            <div class="login-card-title">
              {{ $t("unlock") }}
            </div>
            <div class="login-features">
              <div class="feature">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                  >
                    <path
                      d="M5.4343 11.6971L0.234305 6.49705C-0.0781016 6.18465 -0.0781016 5.67812 0.234305 5.36568L1.36565 4.2343C1.67805 3.92187 2.18462 3.92187 2.49702 4.2343L5.99999 7.73724L13.503 0.234305C13.8154 -0.0781016 14.3219 -0.0781016 14.6343 0.234305L15.7657 1.36568C16.0781 1.67809 16.0781 2.18462 15.7657 2.49705L6.56568 11.6971C6.25324 12.0095 5.74671 12.0095 5.4343 11.6971Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  style="
                    text-align: left;
                    display: flex;
                    width: 100%;
                    align-items: flex-start;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span
                    style="font-weight: 600; width: 100%"
                    v-if="checkWindowHeight"
                    >{{ $t("exclusive") }}
                    <span>: </span>
                  </span>
                  <span
                    ><span style="color: #efcc3a">{{
                      $t("members-only")
                    }}</span>
                    {{ $t("pricing") }}</span
                  >
                </div>
              </div>
              <div class="feature">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                  >
                    <path
                      d="M5.4343 11.6971L0.234305 6.49705C-0.0781016 6.18465 -0.0781016 5.67812 0.234305 5.36568L1.36565 4.2343C1.67805 3.92187 2.18462 3.92187 2.49702 4.2343L5.99999 7.73724L13.503 0.234305C13.8154 -0.0781016 14.3219 -0.0781016 14.6343 0.234305L15.7657 1.36568C16.0781 1.67809 16.0781 2.18462 15.7657 2.49705L6.56568 11.6971C6.25324 12.0095 5.74671 12.0095 5.4343 11.6971Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  style="
                    text-align: left;
                    display: flex;
                    width: 100%;
                    align-items: flex-start;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span
                    style="font-weight: 600; width: 100%"
                    v-if="checkWindowHeight"
                    >{{ $t("realtime") }} <span>: </span></span
                  ><span>{{ $t("monitor") }}</span>
                </div>
              </div>
              <div class="feature">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                  >
                    <path
                      d="M5.4343 11.6971L0.234305 6.49705C-0.0781016 6.18465 -0.0781016 5.67812 0.234305 5.36568L1.36565 4.2343C1.67805 3.92187 2.18462 3.92187 2.49702 4.2343L5.99999 7.73724L13.503 0.234305C13.8154 -0.0781016 14.3219 -0.0781016 14.6343 0.234305L15.7657 1.36568C16.0781 1.67809 16.0781 2.18462 15.7657 2.49705L6.56568 11.6971C6.25324 12.0095 5.74671 12.0095 5.4343 11.6971Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  style="
                    text-align: left;
                    display: flex;
                    width: 100%;
                    align-items: flex-start;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <span
                    style="font-weight: 600; width: 100%"
                    v-if="checkWindowHeight"
                    >{{ $t("order-history") }} <span>: </span></span
                  ><span>{{ $t("easy-review") }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="login-button" @click="redirectToLogin('Login')">
              Login
            </div> -->
            <div class="login-button" @click="redirectToLogin('SignUp')">
              {{ $t("create-acc") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showScrollToTop" class="scroll-to-top" @click="scrollToTop">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0306 9.53073C16.9609 9.60046 16.8782 9.65578 16.7871 9.69352C16.6961 9.73127 16.5985 9.75069 16.4999 9.75069C16.4014 9.75069 16.3038 9.73127 16.2127 9.69352C16.1217 9.65578 16.039 9.60046 15.9693 9.53073L8.99993 2.56041L2.03055 9.53073C1.88982 9.67146 1.69895 9.75052 1.49993 9.75052C1.30091 9.75052 1.11003 9.67146 0.969304 9.53073C0.828573 9.39 0.749512 9.19912 0.749512 9.0001C0.749512 8.80108 0.828573 8.61021 0.969304 8.46948L8.4693 0.969476C8.53896 0.899744 8.62168 0.844425 8.71272 0.806682C8.80377 0.768939 8.90137 0.749512 8.99993 0.749512C9.09849 0.749512 9.19608 0.768939 9.28713 0.806682C9.37818 0.844425 9.4609 0.899744 9.53055 0.969476L17.0306 8.46948C17.1003 8.53913 17.1556 8.62185 17.1933 8.7129C17.2311 8.80395 17.2505 8.90154 17.2505 9.0001C17.2505 9.09866 17.2311 9.19626 17.1933 9.28731C17.1556 9.37836 17.1003 9.46107 17.0306 9.53073Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
  <ReferralCredits
    v-if="showReferralCreditsModal"
    @close="closeReferralCreditsModal"
  />
  <RequestReportStatus
    v-if="showRequestReportStatusModal"
    @close="closeRequestReportStatusModal"
  />
  <Toastify ref="toastContainer" />
</template>
<script>
import {
  AllCountries,
  ProductVariant,
  RequestReport,
  UserDetails,
  GetBanksList,
  Search,
  DownloadReportPDF,
  getPiDataFromParser,
  UploadPiFIle,
} from "@/api/APIs";
import InformationList from "@/components/InformationList.vue";
import VueCookies from "vue-cookies";
import NoData2 from "@/assets/Animation/NoData2/NoData2.vue";
import Toastify from "@/components/Toastify.vue";
import SearchAnimation from "@/assets/Animation/SearchAnimation/SearchAnimation.vue";
import { mapGetters } from "vuex";
import ReferralCredits from "@/views/Modals/ReferralCredits.vue";
import RequestReportStatus from "@/views/Modals/RequestReportStatus.vue";

export default {
  name: "SearchForCompanies",
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem("previousRoute", this.saveRoute);
    next();
  },
  components: {
    InformationList,
    NoData2,
    Toastify,
    SearchAnimation,
    ReferralCredits,
    RequestReportStatus,
  },
  props: {
    property1: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      uploadedFile: null,
      uploadedFileName: "",
      intervalId: null,
      parserApiInterval: null,
      progressWidth: 0,
      showScrollToTop: false,
      typeValue: "",
      typeStatus: false,
      txId: "",
      typingSpeed: 100,
      erasingSpeed: 100,
      newTextDelay: 2000,
      displayTextArrayIndex: 0,
      charIndex: 0,
      showTooltip: true,
      isBubbleClicked: false,
      company_name: "",
      selectedCountry: {},
      countries: [],
      filteredCountries: [],
      showResultsFlag: false,
      showResultsFlag1: false,
      searchResults: null,
      resultsAdditionalInformation: null,
      showOrderConfirmation: false,
      clickedSearchResult: null,
      productVariant: null,
      selectedCompanyName: "",
      buttonStatus: "",
      note: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isSafari: false,
      hoveredRow: null,
      isProduction: process.env.NODE_ENV === "production",
      recentSearches: null,
      isLoading: true,
      isMobile: window.innerWidth < 1023,
      mobile: window.innerWidth <= 767,
      tablet: window.innerWidth <= 1156,
      showReferralCreditsModal: false,
      pastEntityOrders: null,
      showBlinking: false,
      showBoxShadow: false,
      showRequestReportStatusModal: false,
      sendReportButton: false,
      arrowUsed: false,
      bankName: null,
      banksList: null,
      showManualOrderRM: false,
      transactionId: null,
      userToken: "",
      displayTextArray: [
        this.$t("fresh-data"),
        this.$t("in-depth-summary"),
        this.$t("cross-border-expertise"),
        this.$t("kyc-aml"),
      ],
      enablePiFlow: process.env.VUE_APP_ENABLE_PI === "true",
    };
  },
  watch: {
    pastEntityOrders(newVal) {
      if (newVal !== null) {
        this.triggerBoxShadow();
      }
    },
  },
  created() {
    // setTimeout(this.typeText, this.newTextDelay + 200);
  },
  beforeMount() {
    this.userToken = VueCookies.get("token");
  },
  mounted() {
    if (this.userDetails?.includes("OFFLINE_ORDERS")) {
      this.BanksList();
    }
    this.isSafari = this.detectSafari();
    const company = this.$route.params.company;
    const country = this.$route.params.country;
    if (company) {
      this.company_name = company.replace(/-/g, " ");
    }
    if (this.$store.getters.isReferralCodePresent) {
      this.showReferralCreditsModal = true;
    }
    this.fetchCountryList(country);

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("resize", this.handleResponsive);
    window.addEventListener("scroll", () => {
      this.handleScroll();
      this.handleScrollToTop();
    });
    this.handleScroll();
    sessionStorage.clear();
  },
  computed: {
    tabelColumns() {
      return [
        this.$t("company-name"),
        this.$t("additional-info"),
        this.$t("order-report"),
      ];
    },
    // displayTextArray() {
    //   return [
    //     this.$t("fresh-data"),
    //     this.$t("in-depth-summary"),
    //     this.$t("cross-border-expertise"),
    //     this.$t("kyc-aml")
    //   ]},
    ...mapGetters(["cartCount", "sessionExpired", "userDetails"]),
    isPiFlowAccessible() {
      let isAccessible = false;
      if (
        this.userToken &&
        !this.userDetails?.includes("OFFLINE_ORDERS") &&
        this.enablePiFlow
      ) {
        isAccessible = true;
      } else {
        isAccessible = false;
      }
      return isAccessible;
    },
    saveRoute() {
      const fullRoute =
        this.selectedCountry?.name && this.company_name
          ? `/search/${this.selectedCountry?.name?.replace(
              /\s+/g,
              "-"
            )}/${this.company_name?.replace(/\s+/g, "-")}`
          : `/search`;

      return JSON.stringify(fullRoute);
    },
    checkWindowHeight() {
      return this.windowHeight > 800;
    },
    userTokenAvailable() {
      return this.userToken !== null;
    },
    hoverStyle() {
      return this.isSafari
        ? {
            borderRadius: "13px",
            background: "rgba(38, 187, 194, 0.2)",
          }
        : {
            borderRadius: "13px",
            background:
              "linear-gradient(133deg, rgba(38, 187, 194, 0.2) 27.88%, rgba(24, 207, 215, 0) 79.91%), #3673ae14",
          };
    },
    contentWrapperWidth() {
      return this.userTokenAvailable ? "100%" : "75%";
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.handleResponsive);
    window.removeEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    clearInterval(this.parserApiInterval);
    clearTimeout(this.intervalId);
  },
  methods: {
    async downloadReport(fileKey, fileName) {
      const fileExtension = fileName.split(".").pop();
      let payload = {
        fileKey: fileKey,
      };
      try {
        const response = await DownloadReportPDF(payload);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new File([response.data], `${fileName}`, {
            type: `application/${fileExtension}`,
          })
        );
        link.download = `${fileName}`;
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Oops! Something went wrong, Please try again later",
            {
              type: "error",
            }
          );
        }
      }
    },
    // Increase width of progress bar for 48 second
    startProgress() {
      clearInterval(this.intervalId);
      this.progressWidth = 0; // Reset progress width

      const maxProgress = this.mobile ? 60 : 90;
      const duration = 48000; // Total time in ms
      const interval = this.mobile ? 200 : 100; // Interval duration
      const step = (maxProgress / duration) * interval;

      this.intervalId = setInterval(() => {
        this.progressWidth += step;
        if (this.progressWidth >= maxProgress) {
          this.progressWidth = maxProgress;
          clearInterval(this.intervalId);
        }
      }, interval);
    },
    // call parseur get api on intervals
    async startFetchingParsedData() {
      clearInterval(this.parserApiInterval);
      this.parserApiInterval = setInterval(() => {
        this.getParsedPiData();
      }, 5000);
      // Clear Interval after 45 seconds
      setTimeout(() => {
        this.resetClearIntervals(0);
        this.$refs.toastContainer?.addToast(
          "Something went wrong. Please try again later.",
          { type: "error" }
        );
      }, 45000);
    },
    // Handle parseur get api
    async getParsedPiData() {
      try {
        const response = await getPiDataFromParser(this.transactionId);
        if (response?.transaction?.processingStatus === "PROCESSED") {
          const companyDetails = JSON.stringify(response?.transactionDetails);
          sessionStorage.setItem("companyDetails", companyDetails);
          sessionStorage.setItem(
            "filePreviewUrl",
            response?.transaction?.s3PiFileKey
          );
          this.resetClearIntervals(100);
        } else if (response?.transaction?.processingStatus === "FAILED") {
          // Reset on failure
          this.resetClearIntervals(0);
          this.$refs.toastContainer.addToast(response?.message, {
            type: "error",
          });
        }
      } catch (error) {
        // Reset on error
        this.resetClearIntervals(0);
        if (error?.response && error?.response?.status !== 403) {
          this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },

    // Clear Intervals and reset width of progress bar
    resetClearIntervals(width) {
      clearInterval(this.parserApiInterval);
      clearInterval(this.intervalId);
      this.progressWidth = width;
      if (width === 100 && this.progressWidth >= 60) {
        this.$router.push("/pi-order");
      } else if (width === 0) {
        this.uploadedFile = null;
        this.uploadedFileName = null;
      }
    },

    async UserDetails() {
      try {
        const response = await UserDetails(
          VueCookies.get("email"),
          VueCookies.get("token")
        );
        if (!response) {
          return true;
        }
        const countryValue = response?.entityCountryId || null;
        sessionStorage.setItem("entityCountryId", countryValue);
        return false;
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
        return true;
      }
    },
    async triggerFileUpload() {
      const shouldLogout = await this.UserDetails();
      if (shouldLogout) {
        this.$store.dispatch("processLogout");
        return;
      }
      this.$refs.fileInput.click();
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const allowedTypes = ["application/pdf", "application/jpeg"];

      if (
        !allowedTypes.includes(file.type) &&
        !file.type.startsWith("image/")
      ) {
        event.target.value = "";
        return this.$refs.toastContainer.addToast(
          "Invalid file type. Please upload a valid file.",
          { type: "error" }
        );
      }

      if (file?.size > 2 * 1024 * 1024) {
        return this.$refs.toastContainer.addToast(
          "File size should not excced 2 MB",
          { type: "error" }
        );
      }
      const formData = new FormData();
      formData.append("userId", VueCookies.get("id"));
      formData.append("file", file);
      try {
        // start progress bar
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.startProgress();
        // call upload pi api
        const response = await UploadPiFIle(formData);
        if (response && response?.status === 200) {
          this.transactionId = response?.data?.transaction?.transactionId;
          // call, get parsed data api
          this.startFetchingParsedData();
        }
      } catch (error) {
        this.resetClearIntervals(0);
        return this.$refs.toastContainer.addToast(
          "Error occurred during upload. Please try again later.",
          { type: "error" }
        );
      }
    },
    rearrangedAdditionalInfo(additionalInfo) {
      if (!additionalInfo || typeof additionalInfo !== "object") {
        return additionalInfo;
      }
      const { more_information, ...rest } = additionalInfo;
      if (more_information) {
        return { ...rest, more_information };
      }
      return additionalInfo;
    },
    showManualOrderModalRM() {
      if (this.selectedCompanyName || this.company_name) {
        sessionStorage.setItem(
          "selectedCompanyName",
          this.selectedCompanyName || this.company_name
        );
      }
      if (this.bankName) {
        sessionStorage.setItem("selectedBank", JSON.stringify(this.bankName));
      }
      this.$router.push("/rm-single-order");
    },
    hideManualOrderModalRM() {
      this.clickedSearchResult = null;
      this.selectedCompanyName = "";
      this.productVariant = null;
      this.showManualOrderRM = false;
    },
    async BanksList() {
      try {
        const response = await GetBanksList("");
        if (response) {
          this.banksList = response?.allEntitiesResults;
        } else {
          this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async tokenAPI() {
      try {
        const response = await UserDetails(
          VueCookies.get("email"),
          this.userToken
        );
        if (response) {
          if (this.userDetails?.includes("OFFLINE_ORDERS")) {
            if (
              this.userDetails?.includes("OFFLINE_ORDERS") === true &&
              this.bankName === null
            ) {
              return this.$refs.toastContainer.addToast(
                "Please select a Bank.",
                {
                  type: "error",
                }
              );
            }
            this.showManualOrderModalRM();
          } else {
            this.showManualOrderModal();
          }
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async RequestAvailableReport(value) {
      this.sendReportButton = true;
      const payload = {
        companyName: value.company_name,
        companyAddress: value.additional_info?.business_address,
        entityName: value.user_entity,
        userEmail: VueCookies.get("email"),
        reportDeliveryDate: value.reportDated,
      };
      try {
        const response = await RequestReport(payload);
        if (
          response.success ==
          "Report request email sent to business user sucessfully."
        ) {
          this.showRequestReportStatusModal =
            !this.showRequestReportStatusModal;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } finally {
        this.sendReportButton = false;
      }
    },
    triggerBoxShadow() {
      this.showBoxShadow = true;
      this.showBlinking = true;
    },
    closeRequestReportStatusModal() {
      this.showRequestReportStatusModal = false;
    },
    closeReferralCreditsModal() {
      this.showReferralCreditsModal = false;
      this.$store.dispatch("setIsReferralCodePresent", false);
    },
    redirectToSampleReports() {
      this.$router.push("/sample-reports");
    },
    handleResponsive() {
      this.isMobile = window.innerWidth < 1023;
    },
    recentSearch(search) {
      const company = search.searchQuery;
      const country = search.countryName;
      if (company) {
        this.company_name = company.replace(/-/g, " ");
      }
      this.fetchCountryList(country);
    },
    redirectToLogin(type) {
      this.$router.push({ path: "/login", query: { type: type } });
    },
    handleScrollToTop() {
      this.showScrollToTop = window.scrollY > 200;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      const loginCard = this.$refs.loginCard;
      if (!loginCard) {
        return;
      }
      if (window.scrollY > 90) {
        loginCard.style.position = "sticky";
        loginCard.style.top = "125px";
      } else {
        loginCard.style.position = "relative";
        loginCard.style.top = "auto";
      }
    },
    detectSafari() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
    },
    setHover(index) {
      this.hoveredRow = index;
    },
    clearHover() {
      this.hoveredRow = null;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    isWindows() {
      return /Windows/.test(window.navigator.userAgent);
    },
    typeText() {
      if (
        this.charIndex <
        this.displayTextArray[this.displayTextArrayIndex]?.length
      ) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue += this.displayTextArray[
          this.displayTextArrayIndex
        ].charAt(this.charIndex);
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue = this.displayTextArray[
          this.displayTextArrayIndex
        ].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.displayTextArrayIndex += 1;
        if (this.displayTextArrayIndex >= this.displayTextArray.length)
          this.displayTextArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    },
    updateSelectedCountry(event) {
      this.selectedCountry = {
        ...this.selectedCountry,
        name: event.target.value,
      };
      sessionStorage.setItem(
        "selectedCountry",
        JSON.stringify(this.selectedCountry)
      );
      this.filterCountries();
    },
    filterCountries() {
      const searchTerm = this.selectedCountry.name
        ? this.selectedCountry.name.toLowerCase()
        : "";
      this.filteredCountries = this.countries.filter((country) =>
        country.name.toLowerCase().includes(searchTerm)
      );
      this.showResultsFlag = true;
    },
    // selectCountry(country) {
    //   this.selectedCountry = country;
    //   sessionStorage.setItem(
    //     "selectedCountry",
    //     JSON.stringify(this.selectedCountry)
    //   );
    //   if (country?.searchNotes !== null) {
    //     this.note = true;
    //   }
    //   this.filteredCountries = [];
    // },
    // showResults() {
    //   this.showResultsFlag = true;
    //   this.filteredCountries = this.countries;
    //   document.addEventListener("click", this.closeResultsOnClickOutside);
    // },
    // closeResultsOnClickOutside(event) {
    //   const searchInput = this.$refs.searchInput;
    //   const countryResults = this.$refs.countryResults;
    //   console.log(this.$refs.searchInput,'searchhhhhhh');

    //   if (
    //     searchInput &&
    //     !searchInput.contains(event.target) &&
    //     countryResults &&
    //     !countryResults.contains(event.target)
    //   ) {
    //     this.showResultsFlag = false;
    //     document.removeEventListener("click", this.closeResultsOnClickOutside);
    //   }
    // },
    selectCountry1(country) {
      this.selectedCountry = country;
      sessionStorage.setItem(
        "selectedCountry",
        JSON.stringify(this.selectedCountry)
      );
      if (country?.searchNotes !== null) {
        this.note = true;
      }
      this.filteredCountries = [];
    },
    toggleDropdown1() {
      this.showResultsFlag1 = this.showResultsFlag1 ? false : true;
      this.$refs.searchInput.focus();
      this.filteredCountries = this.countries;
    },
    showResults1() {
      this.showResultsFlag1 = true;
      this.filteredCountries = this.countries;
      document.addEventListener("click", this.closeResultsOnClickOutside1);
    },
    closeResultsOnClickOutside1(event) {
      const searchInput = this.$refs.searchInput;
      const countryResults = this.$refs.countryResults;
      if (
        searchInput &&
        !searchInput.contains(event.target) &&
        countryResults &&
        !countryResults.contains(event.target)
      ) {
        this.showResultsFlag1 = false;
        // document.removeEventListener("click", this.closeResultsOnClickOutside);
      }
    },
    async fetchCountryList(country) {
      try {
        const response = await AllCountries(false, true);
        this.countries = await response.allCountries;
        if (country) {
          const matchedCountry = this.countries.find(
            (c) =>
              c.name.toLowerCase() === country.replace(/-/g, " ").toLowerCase()
          );
          if (matchedCountry) {
            this.selectedCountry = matchedCountry;
            sessionStorage.setItem(
              "selectedCountry",
              JSON.stringify(this.selectedCountry)
            );
          }
          if (
            (this.company_name &&
              !this.userDetails?.includes("OFFLINE_ORDERS")) ||
            (this.selectedCountry &&
              !this.userDetails?.includes("OFFLINE_ORDERS"))
          ) {
            this.search();
          }
        }
      } catch (error) {
        this.loginError = "Error occurred during login.";
        console.error(error);
      }
    },
    BubbleClicked() {
      this.isBubbleClicked = !this.isBubbleClicked;
      this.showTooltip = !this.showTooltip;
      this.$emit("bubble-clicked", this.isBubbleClicked);
    },
    async passClickedData(searchResult, buttonStatus) {
      try {
        this.productVariant = null;
        const companyIdentifier =
          searchResult?.additional_info?.company_identifiers?.[0];
        if (companyIdentifier) {
          const key = companyIdentifier.name.toLowerCase();
          const value = companyIdentifier.value;
          let payload = {
            countryId: this.selectedCountry?.id,
            companyIdentifier: {
              [key]: value,
            },
            availableVariants: {
              product_options: searchResult?.product_options,
            },
          };
          if (searchResult?.dpId) {
            payload.dpId = searchResult.dpId;
          }
          if(searchResult?.data_source){
          payload.data_source = searchResult?.data_source;
        }
          const response = await ProductVariant(payload);
          if (response.message === "SUCCESS") {
            this.productVariant = response;
            sessionStorage.setItem("productVariant", JSON.stringify(response));
          } else {
            return this.$refs.toastContainer.addToast(
              "Something went wrong! Please try again later.",
              { type: "error" }
            );
          }
        } else {
          let payload = {
            countryId: this.selectedCountry?.id,
            companyIdentifier: {},
            availableVariants: {
              product_options: searchResult?.product_options,
            },
          };
          if (searchResult?.dpId) {
            payload.dpId = searchResult.dpId;
          }
          if(searchResult?.data_source){
          payload.data_source = searchResult?.data_source;
        }
          const response = await ProductVariant(payload);
          if (response.message === "SUCCESS") {
            this.productVariant = response;
            sessionStorage.setItem("productVariant", JSON.stringify(response));
          } else {
            return this.$refs.toastContainer.addToast(
              "Something went wrong! Please try again later.",
              { type: "error" }
            );
          }
        }
        this.clickedSearchResult = searchResult;
        sessionStorage.setItem(
          "clickedSearchResult",
          JSON.stringify(searchResult)
        );
        this.selectedCompanyName = searchResult.company_name;
        sessionStorage.setItem(
          "selectedCompanyName",
          searchResult.company_name
        );
        this.buttonStatus = buttonStatus;
        sessionStorage.setItem("buttonStatus", buttonStatus);
        if (this.userDetails?.includes("OFFLINE_ORDERS")) {
          this.showManualOrderModalRM();
        } else {
          this.showOrderDetailsModal();
        }
      } catch {
        return this.$refs.toastContainer.addToast(
          "Something went wrong! Please try again later.",
          { type: "error" }
        );
      }
    },

    async search() {
      this.searchResults = null;
      this.resultsAdditionalInformation = null;
      const formattedCountry = this.selectedCountry?.name?.replace(/\s+/g, "-");
      const formattedCompany = this.company_name?.replace(/\s+/g, "-");
      if (!this.company_name) {
        return this.$refs.toastContainer.addToast(
          "Company Name can not be empty.",
          { type: "error" }
        );
      } else if (this.company_name.trim().split(/\s+/).length < 2) {
        return this.$refs.toastContainer.addToast(
          "Please enter at least two words for the search.",
          { type: "warning" }
        );
      } else if (!this.selectedCountry.id) {
        return this.$refs.toastContainer.addToast(
          "Please select a Country first.",
          { type: "error" }
        );
      } else if (
        this.userDetails?.includes("OFFLINE_ORDERS") === true &&
        this.bankName === null
      ) {
        return this.$refs.toastContainer.addToast("Please select a Bank.", {
          type: "error",
        });
      } else {
        const newUrl = `/search/${formattedCountry}/${formattedCompany}`;
        history.replaceState(null, "", newUrl);
        this.isLoading = false;
        this.$root.showLoader();
        let requestBody = {
          companyName: this.company_name,
          countryId: this.selectedCountry.id,
        };
        if (
          this.userDetails?.includes("OFFLINE_ORDERS") === true &&
          this.bankName !== null
        ) {
          requestBody.entityId = this.bankName?.id;
        }
        try {
          let response = await Search(requestBody);
          this.searchResults = response.allSearchResults;
          this.recentSearches = response?.savedSearches;
          if (response?.pastEntityOrders) {
            this.pastEntityOrders = Array.isArray(response?.pastEntityOrders)
              ? response?.pastEntityOrders[0]
              : null;
          }
          this.resultsAdditionalInformation = [];
        } catch (error) {
          this.$root.hideLoader();
          if (error.response && error.response.status !== 403) {
            return this.$refs.toastContainer.addToast(
              "Something went wrong. Please try again later.",
              { type: "error" }
            );
          }
        }
      }
      this.$root.hideLoader();
    },
    getDaysAgo(date) {
      let currentDate = new Date();
      let previousDate = new Date(date);
      let timeDifference = currentDate.getTime() - previousDate.getTime();
      let daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

      return daysDifference;
    },
    showOrderDetailsModal() {
      this.$router.push("/order-details");
    },
    showManualOrderModal() {
      if (this.company_name) {
        sessionStorage.setItem("selectedCompanyName", this.company_name);
      }
      this.$router.push("/manual-order");
    },
  },
};
</script>
<style scoped>
.container {
  background: linear-gradient(to right, #dff3fc, #b2e4f7);
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: left;
}
.beta-version {
  color: var(--Dark-Blue, #224096);
  background: #C94374;
  margin-left: 4px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 20px;
  padding: 6px 12px;
  border: none;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2),
    -5px -5px 10px rgba(255, 255, 255, 0.8);
  display: inline-block;
  color: white;
}
.container h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #003366;
}
.guidelines {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.upload-button {
  display: flex;
  justify-content: flex-end;
}
.upload-button button {
  background-color: white;
  border: 1px solid #003366;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  color: #003366;
  transition: 0.3s;
}
.upload-button button:hover {
  background-color: #003366;
  color: white;
}

/* ============== */
.pi-wrapper {
  display: flex;
  justify-content: center; /* Centers the block */
  width: 100%;
  margin: auto;
}

.pi-frame {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  /* margin: 0px 61px 0px 61px; */
  padding: 24px 10px 10px 24px;
  width: 90%;
  border-radius: 16px;
  /* border: 2px solid #d2d2d2; */
  /* background: linear-gradient(
      0deg,
      rgba(180, 203, 234, 0.6) 0%,
      rgba(180, 203, 234, 0.6) 100%
    ),
    #f2f8ff; */
  background-color: #fff;
  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
}

.pi-content {
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  align-items: flex-start;
  padding-bottom: 18px;
}

.pi-heading {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 18px;
  font-weight: 700;
  /* text-transform: capitalize; */
  /* margin-bottom: 8px; */
}

.pi-subheading {
  font-weight: 400;
  font-size: 16px;
  color: #224096;
  margin-bottom: 4px;
}

.pi-list {
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  padding-left: 20px;
  margin: 0;
  list-style-type: disc;
}

.pi-list li {
  text-align: left;
}

.pi-button-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 26px;
}

.pi-button {
  border-radius: 13px;
  background: #fff;
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.5px;
  cursor: pointer;
  transition: 0.3s;
  position: relative;
  padding: 8px 20px;
  text-align: center;
  width: -webkit-fill-available;
  min-width: 129px;
  display: inline-block;
  background-color: #efcc3a;
  border: none;
  line-height: 28px;
  height: 47px;
}
.progress-frame1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0px;
  width: 100%;
  border-radius: 16px;
  /* border: 2px solid #d2d2d2; */
  /* background: linear-gradient(
      0deg,
      rgba(180, 203, 234, 0.6) 0%,
      rgba(180, 203, 234, 0.6) 100%
    ),
    #f2f8ff; */
  background-color: #ffff;

  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
}

.progress-frame {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 0px 61px 0px 61px;
  padding: 24px 10px;
  width: 90%;
  border-radius: 16px;
  /* border: 2px solid #d2d2d2; */
  /* background: linear-gradient(
      0deg,
      rgba(180, 203, 234, 0.6) 0%,
      rgba(180, 203, 234, 0.6) 100%
    ),
    #f2f8ff; */
  background-color: #ffff;

  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
}

.progress-cards {
  flex: 1 1 0;
  align-self: stretch;
  padding: 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
}

.progress-icons {
  width: 36px;
  height: 36px;
  position: relative;
}

.progress-text {
  align-self: stretch;
  opacity: 0.9;
  text-align: center;
  font-size: 18px;
  font-family: "Figtree";
  font-weight: 700;
  text-transform: capitalize;
  line-height: 25.2px;
  word-wrap: break-word;
}

.rectangle-wrapper {
  flex: 1;
  border-radius: 50px;
  border: 2px solid #224096;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.frame-child {
  position: relative;
  border-radius: 40px;
  background-color: #224096;
  height: 10px;
}

.frame-child1 {
  position: relative;
  border-radius: 40px;
  background-color: #224096;
  height: 10px;
}

/* Hides the default file input button */
.pi-button input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}
input[type="file"]::before {
  content: none;
}
input::placeholder {
  color: #224096;
  opacity: 1;
}

.search-wrapper,
.search-wrapper * {
  box-sizing: border-box;
}
.logged-in {
  margin-left: 18vw;
  padding-top: 55px;
  transition: margin-left 0.3s ease;
}
.logged-in.collapsed {
  margin-left: 60px;
}
.logged-in.notification {
  padding-top: 105px !important;
  height: calc(100vh - 105px);
}
.not-logged-in {
  width: 100%;
}

.country-filter {
  border: none;
}
.search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.search-button {
  background-color: #224096;
  border-radius: 16px;
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  font-family: "Figtree";
  font-size: 18px;
  font-weight: 500;
  align-self: stretch;
  cursor: pointer;
}
.checkout-button {
  background-color: white;
  border: 2px solid #224096;
  border-radius: 16px;
  color: #224096;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  font-family: "Figtree";
  font-size: 18px;
  font-weight: 500;
  align-self: stretch;
  cursor: pointer;
}
.notes {
  padding: 20px;
  border-radius: 16px;
  color: #224096;
  background: #e0f5ff;
  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
}
.flag-image {
  width: 20px;
  height: 15px;
}
.search-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* gap: 1rem; */
}
.search-input {
  background: #ffffff;
  border-radius: 13px;
  display: flex;
  flex-direction: row;
  gap: 100px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  width: 32vw;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(17, 54, 90, 0.5);
}
.enter-email-address {
  color: #3e4855;
  text-align: left;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 500;
  position: relative;
  border: none;
  outline: none;
  box-shadow: none;
  /* height: auto; */
  background-color: white !important;
  margin: 0;
  padding: 19px 24px;
  width: 80%;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}
.main-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 90%;
  gap: 2%;
}
.search-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width: 75%; */
  gap: 1rem;
}
.note-text {
  text-align: left;
  padding-left: 5px;
}
.frame-4 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
.rotate-0 {
  transform: rotate(0deg);
  transition: transform 0.3s ease;
}
.frame-3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  margin-top: 2rem;
}
.search-bar-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  flex-wrap: wrap;
  gap: 2%;
  position: relative;
}
.search-comp {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.frame-6 {
  border-radius: 13px;
  border: 1px solid rgba(17, 54, 90, 0.5);
  display: flex;
  padding: 0;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 200px;
  position: relative;
  background-color: white;
  align-self: stretch;
}
#searchResultTable {
  width: 96.5%;
  border-collapse: collapse;
  border-radius: 16px;
  overflow: hidden;
  background-color: #ffffff;
  font-family: "Figtree";
  margin-bottom: 20px;
}
#searchResultTable th {
  text-align: left;
  background: #e0f5ff;
  color: #224096;
  padding: 8px;
  /* min-width: 30px; */
  padding-left: 30px;
}
#searchResultTable td {
  text-align: left;
  padding: 8px;
  max-width: 800px;
  overflow-wrap: anywhere;
  color: #224096;
}
#searchResultTable td:last-child {
  border-right: none;
}
#order-buttons {
  text-align: center;
  min-width: 250px;
}
.frame-6 select option {
  margin-top: 15%;
  background-color: white;
  height: 200px;
}
#manual-order-div {
  display: flex;
  height: 65vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
}
#manual-order-button {
  height: 35px;
  width: 160px;
  background-color: #224096;
  border: none;
  cursor: pointer;
}
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
  width: 100%;
  background-color: white;
  border-radius: 16px;
  gap: 20px;
  margin-bottom: 1rem;
}
.table-container::-webkit-scrollbar {
  width: 0px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.table-container::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}
.select:focus-visible {
  outline: none;
}
.country-results {
  width: 120%;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background-color: white;
  border-radius: 15px;
  overflow-y: auto;
  top: 115%;
  z-index: 9999;
  box-shadow: 0px 16px 16px 0px rgba(20, 45, 77, 0.1);
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.country-results div {
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding: 5px 10px 5px 20px;
  text-align: left;
  font-size: 14px;
}
.country-results div:hover {
  background-color: #dee9f2;
}
.total-search-results {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.4px;
  text-align: left;
  width: 95%;
  margin-top: 20px;
}
.note-wrapper {
  background-color: #f9fafb;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 96.5%;
  padding: 10px 20px;
  border-radius: 16px;
  gap: 15px;
  top: -22%;
  position: relative;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.25),
    -4px -4px 8px 0px rgba(255, 255, 255, 1);
}
.note-title {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: "Figtree";
  text-align: left;
  gap: 7px;
  font-weight: 500;
}
.search-results-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding: 20px;
}
.company-info-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* gap: 20px; */
  width: 100%;
  padding: 20px;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  width: 70%;
}
.company-info-wrapper:hover {
  border-radius: 13px;
  background: linear-gradient(
      133deg,
      rgba(38, 187, 194, 0.2) 27.88%,
      rgba(24, 207, 215, 0) 79.91%
    ),
    #3673ae14;
}
.company-description {
  text-align: left;
  width: 100%;
}
.company-name-tablet {
  font-size: 16px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
}
#order-buttons-tablet {
  /* width: 30%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.manual-order {
  display: flex;
  position: relative;
  padding: 54.085px 0px;
  flex-direction: column;
  align-items: center;
  gap: 21.634px;
  border-radius: 13.521px;
  background: white;
  width: 100%;
  margin-bottom: 3rem;
}
.manual-order-text {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 27.042px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.541px;
  text-transform: capitalize;
}
.manual-order-button-2 {
  display: flex;
  padding: 16.225px 20.155px;
  align-items: center;
  border: 2px solid #224096;
  font-size: large;
  font-weight: 600;
  font-family: "Figtree";
  border-radius: 16px;
  cursor: pointer;
}
.info-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  gap: 15px;
  padding: 10px;
}
.phone-view-info-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  gap: 5px;
}
.cin-identifiers {
  font-size: 14px;
  font-weight: 600;
  font-family: "Figtree";
}
.identifiers-value {
  font-size: 14px;
  font-family: "Figtree";
}
.login-card {
  background: #224096;
  border-radius: 16px;
  /* max-height: 80vh; */
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  /* align-self: stretch;
  flex-shrink: 0; */
}
.loginwrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  /* height: 100%; */
  position: relative;
  gap: 2rem;
}
.login-card-title {
  color: var(--Other-WHITE, #fff);
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.48px;
  text-align: left;
}
.login-card-description {
  color: var(--Other-WHITE, #fff);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  text-align: left;
  width: 80%;
}
.login-features {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
}
.feature {
  color: white;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  text-align: justify;
  line-height: 150%;
  letter-spacing: 0.18px;
  gap: 15px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.login-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  background-color: #efcc3a;
  border-radius: 16px;
  color: #224096;
  font-weight: 600;
  font-family: "Figtree";
  cursor: pointer;
}
.create-account-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 0;
  border: 2px solid white;
  border-radius: 16px;
  color: white;
  font-weight: 600;
  font-family: "Figtree";
  cursor: pointer;
}
.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  background-color: #224096bd;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.18);
  border-radius: 50%;
  padding: 15px;
  cursor: pointer;
  z-index: 1000;
}
.scroll-to-top:hover {
  background-color: #224096;
}
.scroll-to-top.show {
  display: block;
  gap: 20px;
}
.recent-searches {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 2vw;
}
.frame-132 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.frame-1321 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px 0;
}
.recent-searches-title {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.4px;
  text-transform: capitalize;
}
.clear-all-button {
  color: #3e4855;
  text-align: right;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.16px;
}
.recent-search-capsule {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 13px;
  background: white;
  color: #3e4855;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.16px;
  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
}
.company-name {
  white-space: nowrap;
}
.search-page-animation-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75vh;
  gap: 2vh;
}
.search-page-animation-text {
  color: #224096;
  text-align: center;
  font-family: "Figtree";
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.16px;
  opacity: 0.7;
}
.login-discounts {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  width: fit-content;
  padding: 3px 10px;
  border: 2px solid #224096;
  background: #efcc3a;
  gap: 10px;
}
.search-page-animation-text-2 {
  color: var(--Dark-Blue, #224096);
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: -0.36px;
  /* text-transform: capitalize; */
  opacity: 0.9;
}
.search-page-animation-button {
  display: flex;
  padding: 12px 26px;
  align-items: center;
  gap: 10.1px;
  border-radius: 16px;
  background: var(--Dark-Blue, #224096);
  color: white;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.279px;
  letter-spacing: -0.162px;
  cursor: pointer;
}
.manual-order-cta {
  background-color: white;
  border-radius: 16px;
  color: #224096;
  padding: 0.8rem 1.3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  font-family: "Figtree";
  font-size: 18px;
  font-weight: 500;
  align-self: stretch;
  cursor: pointer;
  border: 2px solid #224096;
  cursor: pointer;
}
.delivered-reports-wrapper {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 13px;
  background: #e0f5ff;
  width: 96.5%;
}
.send-report-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.send-report-title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.send-report-title {
  color: var(--Other-Blue, #142d4d);
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.18px;
}
.send-report-title-2 {
  color: var(--Other-Blue, #142d4d);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.16px;
}
.send-report-button {
  display: flex;
  min-width: 150px;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 13px;
  /* border: 1px solid var(--Dark-Blue, #224096); */
  background: #224096;
  color: white;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  text-transform: capitalize;
  cursor: pointer;
  width: 176px;
}
.send-report-company-name-wrapper {
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
}
.send-report-company-name-title {
  color: var(--Other-Blue, #142d4d);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.16px;
}
.send-report-company-name {
  color: var(--Other-Blue, #142d4d);
  text-align: right;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.16px;
  max-width: 70%;
}
.bank-name-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
}
.banks-list-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 90%;
}
.banks-list {
  height: 52.5px;
  width: 64%;
  align-self: stretch;
  border: 1px solid rgba(17, 54, 90, 0.5);
  border-radius: 13px;
  padding-left: 20px;
  text-align: left;
  font-family: "Figtree";
  font-size: 18px;
  font-weight: 400;
  outline: none;
}
.search-wrapper-not-logged {
  margin-top: 7rem;
}

@keyframes blinking {
  0% {
    box-shadow: 0px 0px 24px 0px rgb(0, 0, 136, 0);
  }
  50% {
    box-shadow: 0px 0px 24px 0px rgb(0, 0, 136) !important;
  }
  100% {
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 136, 0);
  }
}

/* Media query */
@media only screen and (max-width: 767px) {
  .img-icon {
    width: 35px;
  }
  .banks-list {
    height: 30px;
    font-size: 16px;
    border-radius: 0.5em;
    width: 100%;
  }
  .main-wrapper {
    flex-direction: column;
    align-items: center;
  }
  .search-content-wrapper {
    width: 100% !important;
  }
  .login-card {
    width: 100%;
    margin-bottom: 2rem;
  }
  .login-card-title,
  .login-features {
    width: 100%;
  }
  .search-bar-wrapper {
    flex-direction: column;
    gap: 1rem;
  }
  .frame-3 {
    margin-top: 5rem;
  }
  .search-page-animation-wrapper {
    height: 60vh;
  }
  .search-input,
  .frame-6,
  .search-button,
  .checkout-button {
    width: 100%;
    border-radius: 8px;
  }
  .search-comp {
    flex-direction: column;
  }
  .search-button,
  .checkout-button {
    justify-content: center;
  }
  .enter-email-address,
  .search-button,
  .checkout-button {
    padding: 8px 20px;
    font-size: 16px;
  }
  .country-results {
    width: 90%;
  }
  .search-wrapper {
    gap: 1rem;
  }
  .notes {
    padding: 8px;
    border-radius: 8px;
  }
  .note-title {
    font-size: 12px;
  }
  .table-container,
  .wrapper {
    gap: 1rem;
  }
  .company-info-wrapper {
    flex-direction: column;
  }
  .wrapper,
  #order-button-wrapper,
  #order-buttons-tablet,
  #order-buttons-tablet div,
  #order-buttons-tablet div div {
    width: 100% !important;
  }
  #order-buttons-tablet div div {
    justify-content: center;
    border-radius: 8px !important;
    height: 35px;
  }
  .search-results-card,
  .search-results-card,
  .company-info-wrapper {
    padding: 10px;
  }
  .total-search-results {
    font-size: 16px;
  }
  #order-buttons-tablet div {
    padding: 0 !important;
  }
  #manual-order-div div span {
    font-size: 14px;
  }
  #manual-order-button {
    font-size: 14px;
    width: auto;
  }
  .company-description {
    margin-bottom: 1rem;
  }
  .manual-order {
    padding: 10px 0px;
  }
  .manual-order-text {
    font-size: 16px;
  }
  .manual-order-button-2 {
    padding: 10px 15px;
    font-size: 16px;
  }
  .manual-order-cta {
    padding: 0.2984rem 1.3rem;
    border-radius: 8px;
    justify-content: center;
    font-size: 16px;
  }
  .search-page-animation-text {
    font-size: 16px;
  }
  .search-page-animation-text-2 {
    font-size: 14px;
  }
  .search-page-animation-button {
    padding: 4px 18px;
    border-radius: 8px;
  }
  .send-report-title {
    font-size: 16px;
    text-align: left;
    line-height: 20px;
  }
  .send-report-title-2,
  .send-report-company-name-title {
    font-size: 14px;
    text-align: left;
    line-height: 20px;
  }
  .send-report-company-name-title {
    max-width: 17vw;
  }
  .send-report-company-name {
    font-size: 14px;
    text-align: left;
    line-height: 20px;
  }
  .send-report-title-wrapper {
    gap: 2px;
  }
  .send-report-button {
    padding: 2px 10px;
    font-size: 14px;
    align-self: stretch;
    border-radius: 8px;
    width: 100%;
  }
  .send-report-button svg {
    width: 20px;
    height: 20px;
  }
  .send-report-wrapper {
    flex-direction: column;
    gap: 15px;
  }
  .send-report-company-name-wrapper {
    gap: 5px;
    justify-content: flex-start;
  }
  /* Progress bar */
  .pi-frame {
    margin: 0px 15px;
    padding: 15px 24px;
  }
  .pi-list {
    /* background: linear-gradient(
        0deg,
        rgba(180, 203, 234, 0.6) 0%,
        rgba(180, 203, 234, 0.6) 100%
      ),
      #f2f8ff; */
    background-color: white;
  }
  .pi-heading {
    text-align: left;
    margin-bottom: 0px;
  }
  .pi-button-wrapper {
    padding: 0px;
    width: -webkit-fill-available;
  }
  .pi-button {
    width: 100%;
  }

  .progress-frame {
    width: 100%;
    position: relative;
    box-shadow: -4px -4px 8px #fff, 4px 4px 8px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
    /* background: linear-gradient(
        rgba(180, 203, 234, 0.6),
        rgba(180, 203, 234, 0.6)
      ),
      #f2f8ff; */
    background-color: #ffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 24px 30px;
    box-sizing: border-box;
    gap: 16px;
    text-align: left;
  }
  .progress-cards {
    flex: 1 1 0;
    align-self: stretch;
    padding: 0px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 0px;
    display: inline-flex;
  }
  .progress-wrapper1 {
    /* width: 100%; */
    position: relative;
    box-shadow: -4px -4px 8px #fff, 4px 4px 8px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
    /* background: linear-gradient(
        rgba(180, 203, 234, 0.6),
        rgba(180, 203, 234, 0.6)
      ),
      #f2f8ff; */
    background-color: white;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 20px; /* Reduced padding */
    box-sizing: border-box;
    gap: 0px;
    text-align: center;
    width: -webkit-fill-available;
    margin: 0px 18px;
  }
  .progress-frame1 {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px; /* Reduced gap */
    text-align: center;
    border: 2px solid #d2d2d2;
    border: none;
    box-shadow: none;
    padding: 15px 0px;
  }
  .rectangle-wrapper {
    width: 100%;
    position: relative;
    border-radius: 50px;
    border: 2px solid #224096;
    box-sizing: border-box;
    height: 10px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .frame-child {
    position: relative;
    border-radius: 40px;
    background-color: #224096;
    height: 10px;
  }
  .frame-child1 {
    position: relative;
    border-radius: 10px;
    background-color: #224096;
    width: 100%;
    height: 65%;
  }
  .progress-text {
    font-size: 16px;
    font-family: "Figtree";
  }
  .progress-icons {
    width: 35px;
  }
  .frame-parent1 {
    width: 100%;
    position: relative;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 20.8px;
    box-sizing: border-box;
    gap: 27.7px;
    text-align: left;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .img-icon {
    width: 35px;
  }
  .progress-cards {
    gap: 0px;
  }
  .search-wrapper {
    gap: 1rem;
  }

  .frame-3 {
    margin-top: 5.3rem;
  }
  .enter-email-address {
    padding: 12px 15px;
  }
  .notes {
    padding: 12px;
  }
  .note-title {
    font-size: 16px;
  }
  .table-container {
    gap: 1rem;
  }
  .total-search-results {
    font-size: 18px;
  }
  .manual-order-cta {
    padding: 0.675rem 0.5rem;
    font-size: 16px;
  }
  .search-button {
    padding: 0.8rem 0.8rem !important;
    font-size: 16px;
  }
  .search-bar-wrapper {
    gap: 1.5%;
  }
  .enter-email-address {
    font-size: 16px;
  }
  .search-input {
    width: 35vw;
  }
  .search-page-animation-text {
    font-size: 18px;
  }
  .search-page-animation-text-2 {
    font-size: 14px;
  }
  .search-page-animation-button {
    padding: 8px 26px;
  }
  .progress-frame1 {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px; /* Reduced gap */
    text-align: center;
    border: 2px solid #d2d2d2;
    border: none;
    box-shadow: none;
    padding: 15px 0px;
  }
}

@media only screen and (min-width: 1024px) {
}

@media only screen and (min-width: 768px) and (max-width: 1156px) and (max-height: 800px) {
  .login-card {
    /* max-height: 73vh; */
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
}
@media only screen and (min-width: 1156px) and (max-height: 800px) {
  .login-card {
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
}
</style>
